import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {MessageService} from 'primeng/api';
import {finalize, Subject, takeUntil} from 'rxjs';
import {CommonModule} from "@angular/common";
import {DropdownModule} from "primeng/dropdown";
import {MultiSelectModule} from "primeng/multiselect";
import {CalendarModule} from "primeng/calendar";
import {CheckboxModule} from "primeng/checkbox";
import {ButtonModule} from "primeng/button";
import {InputTextModule} from "primeng/inputtext";
import {InputSwitchModule} from "primeng/inputswitch";
import {TableModule} from "primeng/table";
import {DialogModule} from "primeng/dialog";
import {GalleriaModule} from "primeng/galleria";
import {ImageModule} from "primeng/image";
import {ToastModule} from "primeng/toast";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HttpClientModule} from "@angular/common/http";
import {CardModule} from "primeng/card";
import {AuthService} from "../../service/auth.service";
import {User} from "../../models/user.model";
import {LoaderService} from "../../service/loader.service";

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  standalone: true,
  imports: [
    CommonModule,

    DropdownModule,
    MultiSelectModule,
    CalendarModule,
    CheckboxModule,
    ButtonModule,
    InputTextModule,
    InputSwitchModule,
    TableModule,
    DropdownModule,
    DialogModule,
    GalleriaModule,
    ImageModule,
    ToastModule,

    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    CardModule
  ],
  providers: [MessageService]
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
  stylePattern = {'min-width': '100%', 'max-width': '100%', 'height': '40px'};

  private _destroy$: Subject<void> = new Subject<void>();

  currentPassword: string = ''

  newPassword: string = '';

  confirmPassword: string = '';

  user!: User;
  loading: boolean = false;

  constructor(
    public userService: AuthService,
    public loaderService: LoaderService,
    private messageService: MessageService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    const ehPages = this.router.url.includes('pages');
    if (ehPages)
      this.userService.enableChangeLoggedPass();

    this.user = this.userService.getCurrentUser();
  }

  ngOnDestroy() {
    this.userService.disableChangeLoggedPass();
    this.loaderService.hideLoader();
  }

  verifyPassword(password: any): boolean {
    const tamanhoMinimo = 8;
    const regexMaiuscula = /[A-Z]/;
    const regexMinuscula = /[a-z]/;
    const regexNumero = /\d/;
    const regexEspecial = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

    if (!password) {
      return true;
    }

    if (password.length < tamanhoMinimo) {
      return false;
    }

    if (!regexMaiuscula.test(password)) {
      return false;
    }

    if (!regexMinuscula.test(password)) {
      return false;
    }

    if (!regexEspecial.test(password)) {
      return false;
    }

    return regexNumero.test(password);
  }

  changePassword() {
    const data = {
      userId: this.user.id,
      currentPassword: this.currentPassword,
      newPassword: this.newPassword
    }
    this.loading = true;
    this.loaderService.showLoader();
    this.userService.changePassword(data)
      .pipe(
        takeUntil(this._destroy$),
        finalize(() => {
          this.loading = false;
          this.loaderService.hideLoader();
        })
      ).subscribe({
      next: (response: any) => {
        localStorage.clear();
        this.userService.enableChangePassSuccess();
        this.router.navigate(['/login']);
      },
      error: () => {
        this.userService.disableChangePassSuccess();
        this.messageService.add({
          key: 'toastError',
          severity: 'error',
          detail: 'Erro ao tentar alterar a senha, verifique se a senha atual está correta'
        })
      },
      complete: () => {
        this.currentPassword = ''
        this.newPassword = '';
        this.confirmPassword = '';
      }
    });
  }

}
